<template>
  <a-card>
    <a-row :gutter="16" class="batch-info-row">
      <a-col :span="6">
        <div><b>批次编号：</b>{{ detail.batchNo }}</div>
      </a-col>
      <a-col :span="6">
        <div><b>批次名称：</b>{{ detail.convertName }}</div>
      </a-col>
      <a-col :span="6">
        <div>
          <b>兑换码数量：</b>{{ detail.codeCnt }}
          <a-button type="link" @click="exportConvertCode">下载兑换码</a-button>
        </div>
      </a-col>
      <a-col :span="6">
        <div>
          <b>已核销：</b>{{ detail.usedCount }}
          <a-button type="link" @click="goRedeemDetail">兑换详情</a-button>
        </div>
      </a-col>
    </a-row>

    <a-row :gutter="16" class="batch-info-row" style="margin-top: 12px;">
      <a-col :span="6">
        <div><b>未核销：</b>{{ detail.unusedCount }}</div>
      </a-col>
      <a-col :span="6">
        <div><b>启用时间：</b>{{ detail.startTime }}</div>
      </a-col>
      <a-col :span="6">
        <div><b>结束时间：</b>{{ detail.endTime }}</div>
      </a-col>
      <a-col :span="6">
        <div style="display: flex; align-items: center; flex-wrap: wrap;">
          <!-- 状态标题 -->
          <b style="margin-right: 4px;">状态：</b>

          <!-- 状态文字 -->
          <span style="margin-right: 16px;">
      <template v-if="detail.comboStatus === 2">暂停</template>
      <template v-else-if="detail.comboStatus === 1">启用</template>
      <template v-else-if="detail.comboStatus === 0">关闭</template>
      <template v-else>未知</template>
    </span>

          <!-- 操作按钮 -->
          <a-button
              v-if="detail.comboStatus === 1"
              size="small"
              type="primary"
              @click="updateStatus(2)"
          >
            暂停
          </a-button>

          <template v-if="detail.comboStatus === 2">
            <a-button
                size="small"
                type="primary"
                @click="updateStatus(1)"
                style="margin-right: 8px;"
            >
              启用
            </a-button>
            <a-button
                size="small"
                type="primary"
                danger
                @click="updateStatus(0)"
            >
              关闭
            </a-button>
          </template>
        </div>
      </a-col>
    </a-row>

    <a-row style="margin-top: 12px;">
      <a-col :span="24">
        <div><b>用户可兑换短剧数：</b>{{ detail.userUseMax }}</div>
      </a-col>
    </a-row>

    <a-divider />

    <a-row :gutter="16" style="align-items: center; margin-bottom: 16px;">
      <!-- 标题 -->
      <a-col :span="3" style="font-weight: bold; font-size: 16px;">专属二维码</a-col>

      <!-- 开关按钮 -->
      <a-col :span="3">
        <a-switch
            checked-children=""
            un-checked-children=""
            :checked="detail.isAutoGive === 1"
            @change="onQrCodeSwitchChange"
        />
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <!-- 二维码图区域 -->
      <a-col :span="3">
        <div
            style="
          width: 120px;
          height: 120px;
          background-color: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        >
          <img
              v-if="detail.qrCodeUrl"
              :src="detail.qrCodeUrl"
              alt="二维码"
              style="max-width: 100%; max-height: 100%;"
          />
          <span v-else>二维码</span>
        </div>
      </a-col>

      <!-- 下载按钮 -->
      <a-col :span="4" style="display: flex; align-items: center;">
        <a @click="downloadQrCode" style="color: #1890ff; cursor: pointer;">
          下载二维码图片
        </a>
      </a-col>
    </a-row>
<a-divider />

    <!-- 短剧列表 -->
    <div class="video-list" style="margin-top: 16px;">
      <a-table :dataSource="detail.relatedVideoDetailResultList" :pagination="false" rowKey="videoId" bordered>
        <a-table-column title="短剧 ID" dataIndex="videoId" key="videoId" />
        <a-table-column title="短剧名称" dataIndex="videoName" key="videoName" />

        <!-- ✅ 正确写法，使用作用域插槽 slot="coverUrl" -->
        <a-table-column title="短剧封面" key="coverUrl">
          <template slot-scope="text, record">
            <div style="text-align: center;">
              <img
                  :src="record.coverUrl"
                  alt="封面"
                  style="width: 80px; height: 45px; object-fit: cover; border: 1px solid #eee;"
              />
            </div>
          </template>
        </a-table-column>

        <a-table-column title="兑换次数" dataIndex="convertCount" key="convertCount" />
      </a-table>



    </div>

  </a-card>

</template>

<script>
import request from '@/utils/request'
import { Modal, message } from 'ant-design-vue'
import { saveAs } from 'file-saver'
import { exportConvertCode } from '@/api/export/export'

export default {
  name: "ConvertComboDetail",

  data() {
    return {
      detail: {
        batchNo: "",
        convertName: "",
        startTime: "",
        endTime: "",
        codeCnt: 0,
        usedCount: 0,
        unusedCount: 0,
        comboStatus: 0,
        userUseMax: 0,
        relatedVideoDetailResultList: [],
      },
      showQrCode: false,
      qrCodeUrl: "",
    };
  },
  created() {
    const id = this.$route.query.id;
    if (!id) {
      this.$message.error('参数错误：未获取到ID');
      return;
    }
    this.batchId = id;
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      request.get("/video/convertcombo/detail", { params: { comboId: this.batchId } })
          .then((res) => {
            if (res && res.success) {
              this.detail = res.data;
              this.qrCodeUrl = res.data.qrCodeUrl || "";
            }
          });
    },
    async exportConvertCode() {
      try {
        const response = await exportConvertCode(this.batchId)

        // 判断是否是 JSON 错误
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const result = JSON.parse(reader.result);
              message.error(result.message || '下载失败，服务器返回错误');
            } catch (e) {
              message.error('下载失败，返回内容无法解析');
            }
          };
          reader.readAsText(response.data);
          return;
        }

        // 获取文件名
        let fileName = '兑换码_'+this.detail.convertName+'_'+this.detail.batchNo+'.xlsx';
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const match = disposition.match(/filename\*=utf-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        saveAs(blob, fileName);
      } catch (error) {
        console.error('下载失败:', error);
        message.error('下载失败，请检查网络或联系管理员');
      }
    },
    goRedeemDetail() {
      this.$router.push({ name: "RedeemBatchConvertDetail", query: { comboId: this.batchId } });
    },
    updateStatus(newStatus) {
      const statusTextMap = {
        2: '暂停',
        1: '启用',
        0: '关闭',
      };

      Modal.confirm({
        title: '确认操作',
        content: `确定将当前批次状态更新为「${statusTextMap[newStatus]}」吗？`,
        onOk: () => {
          return request.post("/video/convertcombo/updateStatus", {
            comboId: this.batchId,
            status: newStatus,
          }).then(res => {
            if (res && res.success) {
              this.$message.success('状态更新成功');
              this.fetchDetail();
            } else {
              this.$message.error(res.message || '状态更新失败');
            }
          }).catch(() => {
            this.$message.error('请求异常');
          });
        },
      });
    },
    async onQrCodeSwitchChange(checked) {
      const newStatus = checked ? 1 : 0
      try {
        const res = await request.post('/video/convertcombo/updateIsAutoGive', {
          comboId: this.batchId,
          isAutoGive: newStatus
        })
        if (res && res.success) {
          message.success('二维码状态更新成功')
          this.detail.isAutoGive = newStatus
        } else {
          message.error(res.data?.msg || '二维码状态更新失败')
        }
      } catch (e) {
        message.error('二维码状态更新失败')
      }
    },
    downloadQrCode() {
      if (!this.detail.qrCodeUrl) {
        message.warning('暂无二维码可下载')
        return
      }
      const link = document.createElement('a')
      link.href = this.detail.qrCodeUrl
      link.download = 'qrcode.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
};
</script>

<style scoped>
.batch-info-row > .ant-col {
  margin-bottom: 8px;
}
.qrcode-container {
  text-align: center;
}
.video-list {
  margin-top: 16px;
}
</style>
